import { Box, capitalize, Chip, TableCell, TableRow } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { CustomButton } from "src/design/CustomButton";
import {
  colorChipBackground,
  colorChipBorder,
  colorChipText,
  colorTextMuted,
  colorTextPrimary,
  colorTextSecondary,
} from "src/design/tokens";
import { AccountRequest } from "src/data/admin/queries/accountRequest";
import {
  STATUS_CHIP_STYLES,
  STATUS_LABELS,
  formatRequestDate,
} from "../constants";

interface AccountRequestRowProps {
  request: AccountRequest;
  onApprove: (request: AccountRequest) => void;
  onReject: (request: AccountRequest) => void;
}

export const AccountRequestRow = ({
  request,
  onApprove,
  onReject,
}: AccountRequestRowProps) => {
  const chipStyle = STATUS_CHIP_STYLES[request.status];

  return (
    <TableRow
      sx={{
        "&:last-child td": { borderBottom: 0 },
        "&:hover": { backgroundColor: "action.hover" },
      }}
    >
      <TableCell
        sx={{
          pl: 0,
          fontWeight: 500,
          color: colorTextPrimary,
          whiteSpace: "nowrap",
        }}
      >
        {request.firstName} {request.lastName}
      </TableCell>
      <TableCell sx={{ color: colorTextSecondary }}>{request.email}</TableCell>
      <TableCell sx={{ color: colorTextMuted }}>{request.phone}</TableCell>
      <TableCell sx={{ color: colorTextSecondary }}>
        {request.restaurantName}
      </TableCell>
      <TableCell sx={{ color: colorTextMuted }}>{request.cityName}</TableCell>
      <TableCell>
        {request.subscriptionTier ? (
          <Chip
            label={capitalize(request.subscriptionTier)}
            size="small"
            sx={{
              backgroundColor: colorChipBackground,
              color: colorChipText,
              border: `1px solid ${colorChipBorder}`,
              fontWeight: 500,
              fontSize: 12,
            }}
          />
        ) : (
          <Box component="span" sx={{ color: colorTextMuted }}>
            —
          </Box>
        )}
      </TableCell>
      <TableCell>
        <Chip
          label={STATUS_LABELS[request.status]}
          size="small"
          sx={{
            backgroundColor: chipStyle.bg,
            color: chipStyle.color,
            border: `1px solid ${chipStyle.border}`,
            fontWeight: 500,
            fontSize: 12,
          }}
        />
      </TableCell>
      <TableCell sx={{ color: colorTextMuted, whiteSpace: "nowrap" }}>
        {formatRequestDate(request.createdAt)}
      </TableCell>
      <TableCell align="right" sx={{ pr: 0 }}>
        {request.status === "PENDING" && (
          <Box
            sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}
          >
            <CustomButton
              size="small"
              startIcon={<CheckCircleOutlineIcon fontSize="small" />}
              onClick={() => onApprove(request)}
              color="success"
              sx={{ fontSize: 12 }}
            >
              Approve
            </CustomButton>
            <CustomButton
              size="small"
              startIcon={<CancelOutlinedIcon fontSize="small" />}
              onClick={() => onReject(request)}
              color="error"
              variant="outlined"
              sx={{ fontSize: 12 }}
            >
              Reject
            </CustomButton>
          </Box>
        )}
      </TableCell>
    </TableRow>
  );
};
